var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"translate"},[_c('span',{on:{"click":function($event){return _vm.lang('en')}}},[_vm._v("English")]),_vm._v(" "),_c('span',{on:{"click":function($event){return _vm.lang('zh-HK')}}},[_vm._v("繁体中文")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54087858","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/translate/index.vue
// module id = null
// module chunks = 